import { z } from 'zod';
import { LanguageCode } from '../enums';

export const ConfigsStepPostSignQaAnswersTranslations = z.object({
  language_id: LanguageCode,
  sentence: z.string(),
  step_post_sign_qa_answers_id: z.string().uuid(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type ConfigsStepPostSignQaAnswersTranslationsT = z.infer<
  typeof ConfigsStepPostSignQaAnswersTranslations
>;

export const ConfigsStepPostSignQaAnswersTranslationsInsert =
  ConfigsStepPostSignQaAnswersTranslations.partial().merge(
    ConfigsStepPostSignQaAnswersTranslations.pick({
      language_id: true,
      sentence: true,
      step_post_sign_qa_answers_id: true,
    })
  );

export type ConfigsStepPostSignQaAnswersTranslationsInsertT = z.infer<
  typeof ConfigsStepPostSignQaAnswersTranslationsInsert
>;

export const ConfigsStepPostSignQaAnswersTranslationsUpdate =
  ConfigsStepPostSignQaAnswersTranslations.omit({
    created_at: true,
  }).partial();

export type ConfigsStepPostSignQaAnswersTranslationsUpdateT = z.infer<
  typeof ConfigsStepPostSignQaAnswersTranslationsUpdate
>;
